import React, { useContext } from "react";

import { maskingMobile } from "bodycodi/cmap/app/js/common";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import MemberType from "bodycodi/cmap/app/components/common/MemberType";
import call from "bodycodi/cmap/app/img/call.png";
import sms from "bodycodi/cmap/app/img/sms.png";
import comment from "bodycodi/cmap/app/img/comment.png";
import default_customer_profile_64 from "bodycodi/cmap/app/svg/default_customer_profile_64.svg";

type MemberDtlProp = {
  MemberDtlVO: any;
};

const MemberDtl = ({ MemberDtlVO }: MemberDtlProp) => {
  const { dispatch } = useContext(DispatchContext);

  const clickWrite = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "ADD_COMUNITY_POP",
      open: { addComunityPop: true, addComunitySeqmember: MemberDtlVO },
    });
  };

  const handleClickPhone = () => {
    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "callPhone",
        number: MemberDtlVO.mobile,
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.newCoach?.callAndroidPhone(MemberDtlVO.mobile);
    }
  };
  const handleClickMessage = () => {
    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "sendTextMessage",
        number: MemberDtlVO.mobile,
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.newCoach?.sendAndroidTextMessage(MemberDtlVO.mobile);
    }
  };

  return (
    <div className="member-dtl-wrap">
      {Object.keys(MemberDtlVO).length === 3 ? (
        <div className="member-dtl">
          <div className="member-profile">
            <div className="profile skeleton" />
          </div>
          <div className="member-name skeleton"></div>
          <div className="member-type skeleton"></div>
          <div className="member-type skeleton"></div>
        </div>
      ) : (
        <div className="member-dtl">
          <div className="member-profile">
            <img src={MemberDtlVO.imgUrl || default_customer_profile_64} />
            {MemberDtlVO.entranceMemberYn === "Y" && <div className="entrance"></div>}
          </div>
          <div className="member-name">
            {MemberDtlVO.name}
            {MemberDtlVO.age === 0 ? (
              <span className="gray no-age"> &#183; 나이 미설정</span>
            ) : (
              <span className="gray"> &#183; 만 {MemberDtlVO.age}세</span>
            )}
          </div>
          <MemberType
            appointmentMemberYn={MemberDtlVO.appointmentMemberYn}
            chargeMemberYn={MemberDtlVO.chargeMemberYn}
            isSmall={false}
          />
          <div className="member-mobile">{maskingMobile(MemberDtlVO.mobile)}</div>
        </div>
      )}
      <div className="member-dtl-btn-wrap">
        <div className="member-dtl-btn puple" onClick={handleClickPhone}>
          <img src={call} />
          전화
        </div>
        <div className="member-dtl-btn red" onClick={handleClickMessage}>
          <img src={sms} />
          문자
        </div>
        <div className="member-dtl-btn blue" onClick={clickWrite}>
          <img src={comment} />
          글쓰기
        </div>
      </div>
    </div>
  );
};

export default MemberDtl;
